/* ============================================================
   REGINA – Qualitätszertifikate
   assets/section-quality-certificates.js
   ------------------------------------------------------------
   - Sorten-Tabs + Jahrgang-Dropdown filtern die Karten (kombiniert)
   - "Weitere Jahrgänge anzeigen" blendet zusätzliche Karten ein
   - Bei aktivem Filter werden alle Treffer gezeigt (kein Limit)
   ============================================================ */
(function () {
  document.querySelectorAll('[data-qcerts]').forEach(function (section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-cert-card]'));
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.q-tab'));
    var yearSelect = section.querySelector('[data-jahr-select]');
    var moreWrap = section.querySelector('.q-certs-more');
    var moreBtn = section.querySelector('[data-show-more]');
    var visibleCount = parseInt(section.dataset.visibleCount, 10) || 8;

    var activeSorte = 'alle';
    var activeJahr = 'alle';
    var expanded = false;

    function apply() {
      var filtered = activeSorte !== 'alle' || activeJahr !== 'alle';
      var matchCount = 0;
      cards.forEach(function (card) {
        var matches =
          (activeSorte === 'alle' || card.dataset.sorte === activeSorte) &&
          (activeJahr === 'alle' || card.dataset.jahr === activeJahr);
        var visible = false;
        if (matches) {
          matchCount++;
          // Limit gilt nur im ungefilterten, nicht aufgeklappten Zustand
          visible = filtered || expanded || matchCount <= visibleCount;
        }
        card.classList.toggle('is-hidden', !visible);
      });
      // "Mehr anzeigen" nur im ungefilterten, nicht aufgeklappten Zustand
      if (moreWrap) {
        var needMore = !filtered && !expanded && cards.length > visibleCount;
        moreWrap.classList.toggle('is-hidden', !needMore);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        activeSorte = tab.dataset.sorte;
        apply();
      });
    });

    if (yearSelect) {
      yearSelect.addEventListener('change', function () {
        activeJahr = yearSelect.value;
        apply();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = true;
        apply();
      });
    }

    apply();
  });
})();
